import React from "react";
import { MapPin, Phone, ArrowUpRight } from "lucide-react";
import useReveal from "../hooks/useReveal";
import { useContent } from "../context/ContentContext";

export default function Locations() {
  const [ref, inView] = useReveal();
  const { content } = useContent();
  const locations = content.locations;

  return (
    <section id="locations" className="bg-[#F7F2EA] py-24 md:py-32 px-6">
      <div ref={ref} className={`max-w-6xl mx-auto reveal ${inView ? "in-view" : ""}`}>
        <div className="flex items-center gap-4 mb-3">
          <span className="text-xs tracking-[0.25em] text-[#C6A15B] uppercase">/ 05</span>
          <span className="gold-divider" />
          <span className="text-xs tracking-[0.25em] text-[#8A857A] uppercase">Visit Us</span>
        </div>

        <h2 className="font-serif-display text-4xl md:text-6xl text-[#1A1A1A] mb-5">Our Locations</h2>
        <p className="text-[#4A463F] font-light max-w-2xl mb-14 leading-relaxed">
          Find the Skinplicity location nearest you across Kentucky and Ohio. Walk-ins welcome by
          availability — appointments recommended.
        </p>

        <div className="grid md:grid-cols-3 gap-8">
          {locations.map((loc) => (
            <div key={loc.id || loc.name} className="bg-white border border-[#E4DBCB] overflow-hidden flex flex-col">
              <div className="aspect-[4/3] w-full bg-[#EFE7D8]">
                <iframe
                  title={loc.name}
                  src={`https://www.google.com/maps?q=${encodeURIComponent(loc.mapQuery || loc.address)}&output=embed`}
                  className="w-full h-full border-0 grayscale-[0.15]"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-serif-display text-xl text-[#1A1A1A] leading-snug mb-4">
                  {loc.name}
                </h3>
                <div className="space-y-3 text-sm text-[#4A463F] flex-1">
                  <p className="flex items-start gap-3">
                    <MapPin className="text-[#C6A15B] mt-0.5 shrink-0" size={18} strokeWidth={1.5} />
                    <span>{loc.address}</span>
                  </p>
                  {loc.phone ? (
                    <p className="flex items-center gap-3">
                      <Phone className="text-[#C6A15B] shrink-0" size={18} strokeWidth={1.5} />
                      <a href={`tel:${loc.phone.replace(/[^0-9]/g, "")}`} className="hover:text-[#C6A15B] transition-colors">
                        {loc.phone}
                      </a>
                    </p>
                  ) : null}
                </div>
                {loc.directions ? (
                  <a
                    href={loc.directions}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-5 inline-flex items-center gap-2 text-xs tracking-[0.18em] uppercase text-[#C6A15B] hover:gap-3 transition-all"
                  >
                    Get Directions <ArrowUpRight size={16} />
                  </a>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
